import axios from './auth'

const STRUCTURE_BASE_URL = `${process.env.VUE_APP_API_OPS_BASE_URL}/user-structures`;

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  async getStructures({ commit }, params = {}) {
    const url = STRUCTURE_BASE_URL;

    const method = "get";
    const headers = {};
    const config = {
      url,
      method,
      headers,
      params
    };

    try {
      const response = await axios(config);
      let data = response.data.data;
      return {
        status: 'success',
        data,
      };
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data
      };
    }
  },
  async saveStructures({ commit }, payload) {
    const url = STRUCTURE_BASE_URL;

    const method = "post";
    const headers = {
      "Accept": "application/json",
      "Content-Type": "application/json"
    };
    const config = {
      url,
      method,
      data: payload,
      headers
    };

    try {
      const response = await axios(config);
      let data = response.data.data;
      return {
        status: 'success',
        data,
      };
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data
      };
    }
  },
}
